import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { RequestsServices } from './requests.service';
import { from } from 'rxjs';

@Injectable()
export class InvitesService {

  constructor(
    private http: HttpClient,
    private request: RequestsServices
  ) {}

  getInviteMember(): Observable<any> {
    return from(this.request.get({path: 'invite_members', endPoint: '/my-invite'}));
  }

  createInvite(): Observable<any> {
    return from(this.request.post('invite_members', {}, '/create'));
  }

  getMGMConfig(mgmId: string): Observable<any> {
    return from(this.request.get({path: 'member_get_member_admin', pathParam: `/${mgmId}`}));
  }
}
